import React from 'react';
import { Typography } from '~/shared/components/Typography';
import Button from '~/shared/components/Button';
import SparkleIcon from '~/icons/sparkleAi.svg';
import AIGuideWatermark from '~/icons/ai-guide-watermark.svg';
import styles from './PLPHeroAIGuideBanner.module.scss';
import { useTranslation } from '~/shared/utils/translation';
import { useFrame } from '~/shared/utils';
import { useAiChat } from '~/shared/hooks';

interface PLPHeroAIGuideProps {
    title: string;
}
export const PLPHeroAIGuideBanner: React.FC<PLPHeroAIGuideProps> = ({ title }) => {
    const { translate } = useTranslation();
    const { data: frame } = useFrame();
    const { isChatUnavailable, openChat } = useAiChat();
    const fallBackPrompt = `Brugeren har klikket på hjælpeguiden for kategorien {kategori}. Start en guidet dialog, hvor du stiller de spørgsmål, som marketing har defineret for denne kategori, for at hjælpe brugeren med at finde det rigtige produkt ud fra deres behov. Spørgsmålene skal præsenteres med de tilhørende foruddefinerede svarmuligheder (multiple choice) – ikke som åbne fritekstspørgsmål. Stil ét spørgsmål ad gangen, og brug svarene til at præsentere de bedste produkter i kategorien ud fra deres behov. Vis kun de bedste bud minimum 3 max 8.`;
    const prompt = frame.productSettings?.aiGuideBannerPrompt || fallBackPrompt;

    const onSubmitAiChat = () => {
        const aiPrompt = prompt.replaceAll('{kategori}', title);

        openChat(aiPrompt);
    };
    return (
        <div className={styles.aiGuideBanner}>
            <AIGuideWatermark className={styles.aiGuideWatermark} aria-hidden="true" />

            <div className={styles.aiGuideContent}>
                <div className={styles.aiGuideTextGroup}>
                    <Typography className={styles.aiGuideTitle} as="h1" variant="title-M">
                        {`${translate('plp.aiTitle')} ${title}`}
                    </Typography>

                    <Typography className={styles.aiGuideText} as="p" variant="paragraph-L">
                        {translate('plp.aiGuideText')}
                    </Typography>
                </div>

                {frame.settings?.enableAIChatbot && (
                    <Button
                        disabled={isChatUnavailable}
                        variant="primary"
                        className={styles.aiGuideButton}
                        onClick={onSubmitAiChat}
                    >
                        <SparkleIcon className={styles.aiGuideButtonIcon} aria-hidden="true" />
                        {translate('plp.aiStartGuideText')}
                    </Button>
                )}
            </div>
        </div>
    );
};
